import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import toastify from "../../../helper/toastify";
import { login } from "../../../redux/features/auth/authSliceNew";
import LoginOtp from "./LoginOtp";
import deliverygif from "../../../assets/images/Food-Delivery-gif.webp";

const Login = () => {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [otpPhone, setOtpPhone] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phone) {
      toastify.error("Please enter your mobile number");
      return;
    }
    setLoading(true);
    try {
      const response = await dispatch(login({ mobile: phone }));
      if (response.success) {
        // Get the current modal instance
        const loginModalEl = document.getElementById("login-modal");
        const loginModalInstance =
          window.bootstrap.Modal.getInstance(loginModalEl);

        if (loginModalInstance) {
          loginModalInstance.hide(); // ✅ Close the login modal
        } else {
          // fallback in case it's not initialized
          new window.bootstrap.Modal(loginModalEl).hide();
        }

        setOtpPhone(phone);

        // Show OTP modal
        const otpModalEl = document.getElementById("otp-modal");
        let otpModalInstance = window.bootstrap.Modal.getInstance(otpModalEl);
        if (!otpModalInstance) {
          otpModalInstance = new window.bootstrap.Modal(otpModalEl);
        }
        otpModalInstance.show();
      }
    } catch (error) {
      // Check if this is a 401 error that's already been handled by the interceptor
      const is401Error = error.response?.status === 401 || 
                        error.status === 401 ||
                        error._isHandled401 ||
                        error.isHandled;
      
      // If it's a handled 401, don't show error (interceptor already handled logout/redirect)
      if (!is401Error) {
        // Only show error for non-401 errors
        const errorMessage = error.response?.data?.message || error.message || 'An error occurred';
        if (errorMessage && !errorMessage.includes('401')) {
          toastify.error(errorMessage);
        }
      }
      // Silently handle 401 errors as they're already handled by the interceptor
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const loginModalEl = document.getElementById("login-modal");

    const handleModalHidden = () => {
      setPhone(""); // 🔁 Clear input on modal close
    };

    if (loginModalEl) {
      loginModalEl.addEventListener("hidden.bs.modal", handleModalHidden);
    }

    return () => {
      if (loginModalEl) {
        loginModalEl.removeEventListener("hidden.bs.modal", handleModalHidden);
      }
    };
  }, []);

  return (
    <>
      <div
        className="modal fade login-modal"
        id="login-modal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content simple-login-modal">
            <div className="modal-header simple-login-header">
              <div className="simple-login-title">
                <h3 className="modal-title" id="exampleModalLabel">
                  Login
                </h3>
                <p className="simple-login-subtitle">
                  or Create an account
                </p>
              </div>
            </div>
            <div className="modal-body simple-login-body">
              <form onSubmit={handleSubmit} className="simple-login-form">
                <div className="simple-login-illustration">
                  <img src={deliverygif} alt="Food Delivery Animation" className="simple-delivery-img" />
                </div>
                
                <div className="simple-login-input-section">
                  <div className="simple-input-group">
                    <input
                      type="text"
                      className="form-control simple-input"
                      placeholder="Enter Mobile Number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      maxLength="10"
                    />
                  </div>
                  
                  <div className="simple-button-group">
                    <button
                      className="thm-btn fill-btn simple-continue-btn"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? (
                        <span className="simple-spinner">
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <span>Processing...</span>
                        </span>
                      ) : (
                        <span>Continue</span>
                      )}
                    </button>
                  </div>
                </div>

                <div className="simple-login-footer">
                  <p className="simple-terms-text">
                    By clicking on Login, I accept the{" "}
                    <a
                      href="/term-condition"
                      className="simple-terms-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms & Conditions
                    </a>{" "}
                    &{" "}
                    <a
                      href="/privacy-policy"
                      className="simple-terms-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoginOtp phone={otpPhone} />
    </>
  );
};

export default Login;
